var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.364,
    height: 16,
    viewBox: "0 0 20.364 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:#fff}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail_1_",
    "data-name": "mail (1)",
    transform: "translate(0 -54.82)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(0 54.82)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    d: "M1.955 59.752q.386.273 2.33 1.619t2.977 2.074q.114.08.483.347t.614.432q.244.165.591.369a3.428 3.428 0 0 0 .65.307 1.8 1.8 0 0 0 .568.1h.023a1.8 1.8 0 0 0 .568-.1 3.432 3.432 0 0 0 .653-.306q.347-.2.591-.369t.614-.432q.369-.267.483-.347l5.318-3.693a5.4 5.4 0 0 0 1.386-1.4 3 3 0 0 0 .557-1.716 1.834 1.834 0 0 0-1.818-1.818H1.818a1.623 1.623 0 0 0-1.347.591A2.294 2.294 0 0 0 0 56.888a2.654 2.654 0 0 0 .625 1.551 5.64 5.64 0 0 0 1.33 1.313z",
    className: "cls-1",
    "data-name": "Path 30",
    transform: "translate(0 -54.82)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    d: "M19.227 185.426q-3.727 2.523-5.659 3.921-.648.477-1.051.744a6.487 6.487 0 0 1-1.074.545 3.27 3.27 0 0 1-1.25.278h-.023a3.271 3.271 0 0 1-1.25-.278 6.491 6.491 0 0 1-1.074-.545q-.4-.267-1.051-.744-1.534-1.125-5.648-3.921A6.02 6.02 0 0 1 0 184.437v9.023a1.75 1.75 0 0 0 .534 1.284 1.75 1.75 0 0 0 1.284.534h16.728a1.824 1.824 0 0 0 1.818-1.818v-9.023a6.266 6.266 0 0 1-1.137.989z",
    className: "cls-1",
    "data-name": "Path 31",
    transform: "translate(0 -179.278)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.681be28d5b08ab091f25ccd359df0c73.svg";
export { ForwardRef as ReactComponent };